import { commentsItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-chat-1-line"></i>
            网友热议
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">读者评论</h2>
          <p className="text-foreground-600 text-sm">真实网友观点，多元视角看事件</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {commentsItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-4 md:p-5 border border-secondary-200/70"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary-700 font-heading">{item.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1.5">
                    <span className="text-sm font-semibold text-foreground-900">{item.user}</span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
                  <div className="flex items-center gap-4 mt-3">
                    <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
                      <i className="ri-thumb-up-line"></i>
                      <span>{item.likes.toLocaleString()}</span>
                    </button>
                    <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
                      <i className="ri-chat-3-line"></i>
                      <span>回复</span>
                    </button>
                    <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
                      <i className="ri-share-forward-line"></i>
                      <span>分享</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}